export default __webpack_public_path__ + "static/media/account.56a6bced.svg";